import Svg, { SvgProps, Path } from 'react-native-svg';

const StartIcon = (props: SvgProps) => (
  <Svg viewBox="0 0 30 30" width={30} height={30} fill="#FFFFFF" {...props}>
    <Path d="M6 3a1 1 0 0 0-1 1 1 1 0 0 0 0 .004v21.992A1 1 0 0 0 5 26a1 1 0 0 0 1 1 1 1 0 0 0 .58-.188l.002.002 19.834-10.906A1 1 0 0 0 27 15a1 1 0 0 0-.611-.922L6.582 3.186H6.58A1 1 0 0 0 6 3z" />
  </Svg>
);

export default StartIcon;
